var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-preview",style:({
    minWidth: ((_vm.width * 10) + "px"),
    gridTemplateColumns: Array.from({ length: _vm.width }).fill('11px').join(' '),
  }),on:{"click":function($event){return _vm.$emit('loadgrid', _vm.grid)}}},_vm._l((_vm.cols),function(col){return _c('div',{key:col,staticClass:"col"},_vm._l((_vm.rows),function(row){return _c('div',{key:row,staticClass:"cell",class:{ blank: _vm.blanks.includes((col + ":" + row)) }})}),0)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }